<!-- PeriodPanels.vue @save="$emit('save', $event)" -->
<template>
  <div class="panels">
    <PanelItem
      v-for="p in periods"
      :key="p"
      :content="content"
      :period="p"
      :category="category"
      :is-open="currentPeriod === p"
      @toggle="$emit('select', p)"
    />
  </div>
</template>
<script>
import PanelItem from '@/components/compte/bienJouer/PanelItem.vue';

export default {
  name: 'PeriodPanels',
  components: { PanelItem },
  props: {
    content: { type: Object, required: false },
    periods: { type: Array },
    category: { type: String },
    currentPeriod: { type: String, default: null },
  },
};
</script>
